
import { Component, Vue } from "vue-property-decorator";
import AuthHeader from "@/components/layout/auth-header.vue";
import Auth from "@/lib/common/auth";
import { ExamInfo } from "@/lib/model/exam/candidate";
import { Qr } from "@/lib/model/common";
import EditStatus from "@/components/edit-status.vue";
import config from "@/config/config";
import Url from "@/lib/common/url";
@Component({
  components: {
    AuthHeader,
    EditStatus
  }
})
export default class Finish extends Vue {
  isAnonymous = false;
  paperId = "";
  status = "";
  link = "";
  exam = new ExamInfo();
  qr = new Qr();
  mounted() {
    Auth.init()
      .then(() => {
        this.isAnonymous = false;
        this.paperId = Url.query("paperId");
        (async () => {
          await this.getExamx();
          this.link = `${config.apiUrl}/exam/sign?connectCode=${this.exam.connectCode}`;
          await this.getQr();
        })();
      })
      .catch(() => {
        this.isAnonymous = false;
      });
  }
  // 获取考试信息
  async getExamx() {
    this.exam = await ExamInfo.getInfo(this.paperId);
  }
  async getQr() {
    this.qr = await Qr.getQrImage(this.link);
  }
  goBackToList() {
    window.location.href = `${config.apiUrl}/exam/paper?cid=${Auth.companyId}`;
  }
  goAddCandidate() {
    window.location.href = `${config.apiUrl}/add-exam-candidate/${this.paperId}?status=add&redirect=candidateList&cid=${Auth.companyId}`;
  }
  copyLink() {
    const oInput = document.createElement("textarea");
    oInput.value = this.link;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand("Copy");
    oInput.style.display = "none";
    document.body.removeChild(oInput);
    this.$message.success("复制成功");
  }
  downloadBarcode() {
    const a = document.createElement("a");
    a.href = this.qr.linkImage;
    a.setAttribute("download", "在线考试二维码");
    a.click();
  }
}
